import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { ThumbnailWithIcon } from '@lumapps/lumx-images/components/ThumbnailWithIcon';
import { ListItem, Emphasis, Size, ListItemProps } from '@lumapps/lumx/react';

import './index.scss';

export interface GlobalPickerOptionProps {
    /** icon to display */
    icon?: string;
    /** thumbnail URL to display, used in place of icon if both provided */
    thumbnailUrl?: string;
    /** option's name */
    name: string;
    /** option's id */
    id: string;
    /** option's description */
    description: string;
    /** callback to be executed once the item is clicked */
    onClick: ListItemProps['onItemSelected'];
    /** reference that will be added to the item */
    itemRef?: any;
    /** scope for tracking purposes */
    scope: string;
    /** whether the option is disabled or not */
    isDisabled?: boolean;
}

const CLASSNAME = 'global-picker-option';
export const GlobalPickerOption: React.FC<GlobalPickerOptionProps> = ({
    icon,
    thumbnailUrl,
    name,
    description,
    onClick,
    itemRef,
    scope,
    isDisabled,
    id,
}) => {
    const { get } = useDataAttributes(scope);

    return (
        <ListItem
            className={CLASSNAME}
            emphasis={Emphasis.medium}
            onItemSelected={onClick}
            size={Size.big}
            before={<ThumbnailWithIcon image={thumbnailUrl} icon={icon} alt={name} size={Size.m} />}
            isDisabled={isDisabled}
            linkRef={itemRef}
            {...get({
                element: 'option',
                action: id,
            })}
        >
            <p className={`${CLASSNAME}__name`}>{name}</p>
            <p className={`${CLASSNAME}__description`}>{description}</p>
        </ListItem>
    );
};
